import { diContainer } from '../DIContainer';
import { AppStorageKey } from '../types';
import { CashRegister, Terminal } from '../models';
import { Store } from '../wrappers';
import { apiService } from '../services';
import { fiscalServiceLegacy } from '../fiscal';
import localNetworkService from './LocalNetworkService';
const TerminalService = {
    /**
     * Set Terminal
     */
    async setTerminal(terminal, cashRegister) {
        await this.setId(terminal.id);
        Terminal.insert({ data: [terminal] });
        Store.set('terminal', new Terminal(terminal));
        localNetworkService.reload();
        await this.setCashRegister(terminal, cashRegister);
    },
    async setCashRegister(terminal, cashRegister) {
        if (cashRegister && cashRegister?.id === terminal.cash_register_id) {
            CashRegister.insert({ data: [cashRegister] });
        }
        await this.setCashRegisterId(terminal.cash_register_id);
        Store.set('cashRegister', CashRegister.find(terminal.cash_register_id) || null);
        if (terminal.cash_register_id) {
            apiService.setCashRegisterHeader('' + terminal.cash_register_id);
            fiscalServiceLegacy.init();
        }
        else {
            apiService.removeCashRegisterHeader();
        }
    },
    async removeTerminal() {
        await this.removeId();
        Store.set('terminal', null);
        localNetworkService.reload();
        await this.removeCashRegister();
    },
    async removeCashRegister() {
        await this.removeCashRegisterId();
        Store.set('cashRegister', null);
    },
    /**
     * Get Terminal Id
     */
    async getId() {
        const appStorage = diContainer.resolve('appStorage');
        return appStorage.native().getItem(AppStorageKey.terminal);
    },
    /**
     * Set Terminal Id
     */
    async setId(id) {
        const appStorage = diContainer.resolve('appStorage');
        await appStorage.local().setItem(AppStorageKey.terminal, id);
        await appStorage.native().setItem(AppStorageKey.terminal, id);
    },
    /**
     * Remove Terminal Id
     */
    async removeId() {
        const appStorage = diContainer.resolve('appStorage');
        await appStorage.local().deleteItem(AppStorageKey.terminal);
        await appStorage.native().deleteItem(AppStorageKey.terminal);
    },
    /**
     * Get CashRegister Id
     */
    async getCashRegisterId() {
        const appStorage = diContainer.resolve('appStorage');
        return appStorage.native().getItem(AppStorageKey.cashRegister);
    },
    /**
     * Set CashRegister Id
     */
    async setCashRegisterId(id) {
        const appStorage = diContainer.resolve('appStorage');
        await appStorage.local().setItem(AppStorageKey.cashRegister, id);
        await appStorage.native().setItem(AppStorageKey.cashRegister, id);
    },
    /**
     * Remove CashRegister Id
     */
    async removeCashRegisterId() {
        const appStorage = diContainer.resolve('appStorage');
        await appStorage.local().deleteItem(AppStorageKey.cashRegister);
        await appStorage.native().deleteItem(AppStorageKey.cashRegister);
    },
};
export default TerminalService;
export { TerminalService };
//# sourceMappingURL=TerminalService.js.map